import { render } from "./PotentialIssues.vue?vue&type=template&id=7999f63f&scoped=true"
import script from "./PotentialIssues.vue?vue&type=script&lang=js"
export * from "./PotentialIssues.vue?vue&type=script&lang=js"

import "./PotentialIssues.vue?vue&type=style&index=0&id=7999f63f&scoped=true&lang=css"

import exportComponent from "/home/runner/work/acp-portal-frontend/acp-portal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7999f63f"]])

export default __exports__